import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { BaseModal } from '../base-modal';

@Component({
    selector: 'display-enduser-modal',
    templateUrl: 'display-enduser.component.html',
    styleUrls: ['./display-enduser.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class DisplayEnduserModalComponent extends BaseModal {

	constructor(breadcrumbService: BreadcrumbService) {
		super(breadcrumbService);
	}

	onConfirm(): void {
		this.closeAndDestroy();
	}
}
